import { useQuery } from "@tanstack/react-query";
import { getUserByUserId } from "services/users.service";

export const useUserById = (userId, enabled = true, options = {}) => {
  return useQuery({
    queryKey: ["user", userId],
    queryFn: () => getUserByUserId({ userId }),
    enabled: enabled && !!userId,
    select: (data) => data?.data,
    ...options,
  });
};
